import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  faHouse,
  faPeopleRoof,
  faTools,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { DemandScienceDefault } from '@frontend/theme';
import { NavItemService } from '@frontend/util/nav-item-access';
import { navItemChecker$ } from 'application-manager';
import { AuthService } from 'auth';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'ds-platform-home-wrapper',
  template: '<router-outlet></router-outlet>',
  imports: [RouterModule],
  styleUrls: [],
  host: {
    '[style.height]': '"100%"',
  },
})
export class PlatformHomeWrapperComponent {
  constructor() {
    inject(PrimeNG).setConfig({
      theme: {
        preset: DemandScienceDefault,
        options: {
          prefix: '',
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    });
    const authService = inject(AuthService);
    const navItemService = inject(NavItemService);
    navItemService.setAppName('Home');
    navItemService.setUser(authService.actualUserOktaData$);
    navItemService.setNavItems([
      [
        {
          icon: faHouse,
          text: 'Home',
          path: '',
        },
        {
          icon: faUser,
          text: 'Profile',
          path: '/home/profile',
        },
      ],
      [
        {
          text: 'Application Manager',
          tooltip: 'Application Manager',
          icon: faPeopleRoof,
          path: 'home/application-manager',
          customRequirement$: navItemChecker$(),
        },
      ],
      [
        {
          title: 'Admin Tools',
          tooltip: 'Admin Tools',
          icon: faTools,
          requireAdmin: true,
          id: 'admin',
          items: [
            {
              text: 'Switch User',
              tooltip: 'Switch User',
              path: 'home/admin/switch-user',
            },
            {
              text: 'Admin Settings',
              path: 'home/admin/settings',
            },
            {
              text: 'Request Builder',
              path: 'home/admin/request-builder',
            },
            {
              text: 'Admin Entitlement Toggle',
              path: '',
            },
          ],
        },
      ],
    ]);
  }
}
